// Hideo - state of the Home page that outlives it or that the legacy code touches: the clock of the "To do and overdue"
// box, its "Show all" switch, and a counter moved when the "First steps" checklist is hidden (that choice is kept in
// localStorage).
// The clock (startClock, started once by src/main.ts) moves every minute (only while the app is visible) and when
// returning to the app, so the Home box and the Timeline (current-time line, overdue bars: TimelinePage.vue reads
// `now`) follow the real date and time even if the app stays open for days; on a new day it redraws every page (renderAll).
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { isoDay } from '../utils/date'
import { useDataStore } from './data'
import { app } from '../features/app'

export const useHomeStore = defineStore('home', () => {
  const now = ref(Date.now())
  const showAll = ref(false)
  const stepsRev = ref(0)
  /** Moves the Home box to the current time */
  const tick = () => { now.value = Date.now() }

  let day = isoDay(new Date()), started = false
  function clockTick() {
    if (!app.booted || document.hidden || !useDataStore().currentProfile()) return
    tick()
    const today = isoDay(new Date())
    if (today !== day) { day = today; app.renderAll() }   // new day: Home, Board and Calendar too
  }
  function startClock() {
    if (started) return
    started = true
    setInterval(clockTick, 60000)
    document.addEventListener('visibilitychange', () => { if (!document.hidden) clockTick() })
  }
  return { now, showAll, stepsRev, startClock }
})
